export enum ThemeNames {
  BLUE_PULSE = "blue-pulse",
  YELLOW_INDIGO = "yellow-indigo",
  DEFAULT = ""
}